module.exports = __webpack_public_path__ + "img/avatar_matafe_.ebd2e3bc.png";